(() => {
  /* ---------------------------------------------------------
     1) Bilingual disclaimer block (existing)
     --------------------------------------------------------- */
  const NOTE_HTML = `
<div class="wk-pickup-disclaimer" role="note" aria-live="polite">
  <div class="wk-pickup-disclaimer-title">Heads-up｜提示</div>
  <p>
    Some payment methods may still ask for a shipping address.  
    No worries — if you chose <b>Store Pickup</b>, your order will be ready for collection and won’t be shipped.
  </p>
  <p>
    某些付款方式可能仍會要求填寫運送地址。  
    請放心——如選擇<b>門市自取</b>，我們只會準備自取貨品，不會寄送。
  </p>
</div>
  `;

  /* ---------------------------------------------------------
     1b) GTA-only reminder block (NEW)
     --------------------------------------------------------- */
  const GTA_BLOCK_CLASS = "wk-pickup-gta-note";

  const GTA_BLOCK_HTML = `
<div class="${GTA_BLOCK_CLASS}">
  <strong>
    ⚠︎ Store Pickup is available only in the Greater Toronto Area (GTA).  
    Please double-check the pickup address before choosing Store Pickup.<br><br>
    ⚠︎ 門市自取服務只限於大多倫多地區 (GTA)，選擇前請先確認取貨地址。
  </strong>
</div>
  `;

  /* ---------------------------------------------------------
     2) Pickup-location label config (existing)
     --------------------------------------------------------- */
  const PICKUP_LABEL_CLASS = "pickup-location-label";
  const PICKUP_LABEL_TEXT =
    "Pickup Location – choose store | 自取地點－可選擇門市";

  function injectPickupLabel(widget) {
    const selectEl = widget.querySelector("#wk_store_pickup_locations");
    if (!selectEl) return;

    // Already has label?
    if (
      selectEl.previousElementSibling &&
      selectEl.previousElementSibling.classList.contains(PICKUP_LABEL_CLASS)
    ) {
      return;
    }

    const label = document.createElement("div");
    label.className = PICKUP_LABEL_CLASS;
    label.textContent = PICKUP_LABEL_TEXT;

    selectEl.parentNode.insertBefore(label, selectEl);
  }

  /* ---------------------------------------------------------
     3) Disclaimer injection (existing)
     --------------------------------------------------------- */
  function injectDisclaimer(widget) {
    if (!widget || widget.querySelector(".wk-pickup-disclaimer")) return;

    const header = widget.querySelector("h2");
    const container = document.createElement("div");
    container.innerHTML = NOTE_HTML;

    if (header) {
      header.insertAdjacentElement("afterend", container.firstElementChild);
    } else {
      widget.prepend(container.firstElementChild);
    }
  }

  /* ---------------------------------------------------------
     3b) GTA-only block injection (NEW)
     --------------------------------------------------------- */
  function injectGtaBlock(widget) {
    if (!widget || widget.querySelector("." + GTA_BLOCK_CLASS)) return;

    const disclaimer = widget.querySelector(".wk-pickup-disclaimer");
    const temp = document.createElement("div");
    temp.innerHTML = GTA_BLOCK_HTML;
    const node = temp.firstElementChild;

    if (disclaimer) {
      // Place GTA warning immediately under the “Heads-up｜提示” box
      disclaimer.insertAdjacentElement("afterend", node);
    } else {
      const header = widget.querySelector("h2");
      if (header) {
        header.insertAdjacentElement("afterend", node);
      } else {
        widget.prepend(node);
      }
    }
  }

  /* ---------------------------------------------------------
     4) Toggle pickup dropdown + label based on radio
        + inline GTA note beside "Store Pickup" (NEW)
     --------------------------------------------------------- */
  function setupPickupToggle(widget) {
    const selectEl = widget.querySelector("#wk_store_pickup_locations");
    const labelEl = widget.querySelector("." + PICKUP_LABEL_CLASS);
    if (!selectEl || !labelEl) return;

    const radios = widget.querySelectorAll('input[type="radio"]');
    if (!radios.length) return;

    let storePickupRadio = null;
    let storePickupLabelNode = null;

    radios.forEach(radio => {
      const labelNode =
        widget.querySelector(`label[for="${radio.id}"]`) || radio.closest("label");
      const text = labelNode ? labelNode.textContent : "";

      if (
        text &&
        (text.indexOf("Store Pickup") !== -1 ||
          text.indexOf("門市自取") !== -1)
      ) {
        storePickupRadio = radio;
        storePickupLabelNode = labelNode;
      }
    });

    if (!storePickupRadio) return;

    // --- NEW: Inject small inline "(GTA only · 只限多倫多地區)" marker once ---
    if (
      storePickupLabelNode &&
      !storePickupLabelNode.querySelector(".wk-pickup-gta-inline")
    ) {
      const span = document.createElement("span");
      span.className = "wk-pickup-gta-inline";
      span.textContent = " (GTA only · 只限大多倫多地區)";
      storePickupLabelNode.appendChild(span);
    }

    function updateVisibility() {
      const show = storePickupRadio.checked;
      labelEl.style.display = show ? "" : "none";
      selectEl.style.display = show ? "" : "none";
    }

    // Bind change handler once per radio
    radios.forEach(radio => {
      if (radio.dataset.pickupToggleBound) return;
      radio.addEventListener("change", updateVisibility);
      radio.dataset.pickupToggleBound = "1";
    });

    // Initial state on page load / re-render
    updateVisibility();
  }

  /* ---------------------------------------------------------
     5) Master scan — run all injections per widget
     --------------------------------------------------------- */
  function scan() {
    document.querySelectorAll("#wk_store_pickup_div").forEach(widget => {
      // injectDisclaimer(widget);   // existing "Heads-up｜提示"
      injectGtaBlock(widget);     // NEW GTA-only bilingual block
      // injectPickupLabel(widget);  // pickup-location label
      // setupPickupToggle(widget);  // show/hide dropdown + inline GTA tag
    });
  }

  // Initial run
  scan();

  // Observe because Webkul re-renders this block dynamically
  const mo = new MutationObserver(scan);
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
